























































































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import { bargainConfig, saveBargain } from "@/req/dataIndex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
const fontSizeStyle = Quill.import("attributors/style/size");
fontSizeStyle.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
];
Quill.register(fontSizeStyle, true);
@Component({
  components: {
    headerTitle,
    quillEditor,
  },
})
export default class Home extends Vue {
  public baseList: any = {};
  public editorOption = {
    placeholder: "",
    modules: {
      toolbar: [],
    },
  };
  public mounted() {
    this.getList();
  }
  public async getList() {
    const res = await bargainConfig({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      this.baseList = res.data;
    }
  }
  public async save(state) {
    if (state == 1) {
      const res = await saveBargain({
        token: this.$fn.cookies.getToken("token"),
        id: this.baseList.id,
        bond: this.baseList.bond,
        counter_offer: this.baseList.counter_offer,
        payment_time: this.baseList.payment_time,
        seller_cancel_time: this.baseList.seller_cancel_time,
        counter_rate: this.baseList.counter_rate,
        attention: this.baseList.attention,
        bond_description: this.baseList.bond_description,
        commodity_bargain_num: this.baseList.commodity_bargain_num,
        seller_agree_bargain_txt: this.baseList.seller_agree_bargain_txt,
        seller_cancel_bargain_txt: this.baseList.seller_cancel_bargain_txt,
      });
      if (res.code == 0) {
        this.getList();
        this.$Message.success(res.msg);
      }
    }
  }
}
